import React, { useMemo, useState } from 'react';
import { Field, Text, Select, useEmit } from './fields';

/**
 * Emits: { selectedProperty, selectedStore, selectedFloor, selectedUnit,
 *          applicantName, designation, contactNumber, emailAddress }
 * `stores` (optional) populates the store dropdown from the Apply page context.
 */
const TenantInformation = ({ onDataChange, stores = [] }) => {
    const [selectedProperty, setSelectedProperty] = useState('');
    const [selectedStore, setSelectedStore] = useState('');
    const [selectedFloor, setSelectedFloor] = useState('');
    const [selectedUnit, setSelectedUnit] = useState('');
    const [applicantName, setApplicantName] = useState('');
    const [designation, setDesignation] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [emailAddress, setEmailAddress] = useState('');

    const data = useMemo(() => ({
        selectedProperty, selectedStore, selectedFloor, selectedUnit,
        applicantName, designation, contactNumber, emailAddress,
    }), [selectedProperty, selectedStore, selectedFloor, selectedUnit, applicantName, designation, contactNumber, emailAddress]);
    useEmit(data, onDataChange);

    const storeOptions = stores.map((s) => ({ value: s.name || s.value || s, label: s.name || s.label || s }));

    return (
        <div className="v3-wp-card">
            <div className="v3-wp-card-head"><h6 className="v3-wp-card-title">Tenant Details</h6></div>
            <div className="v3-wp-grid">
                <Field label="Property"><Text value={selectedProperty} onChange={setSelectedProperty} placeholder="Property" /></Field>
                <Field label="Store">
                    {storeOptions.length
                        ? <Select value={selectedStore} onChange={setSelectedStore} options={storeOptions} placeholder="Select Store" />
                        : <Text value={selectedStore} onChange={setSelectedStore} placeholder="Store" />}
                </Field>
                <Field label="Floor"><Text value={selectedFloor} onChange={setSelectedFloor} placeholder="Floor" /></Field>
                <Field label="Unit Code"><Text value={selectedUnit} onChange={setSelectedUnit} placeholder="Unit code" /></Field>
                <Field label="Applicant's Full Name" required><Text value={applicantName} onChange={setApplicantName} placeholder="Full name" /></Field>
                <Field label="Designation"><Text value={designation} onChange={setDesignation} placeholder="Designation" /></Field>
                <Field label="Contact Number"><Text value={contactNumber} onChange={setContactNumber} placeholder="971-xx-xxxxxxx" /></Field>
                <Field label="Email Address" required><Text type="email" value={emailAddress} onChange={setEmailAddress} placeholder="name@example.com" /></Field>
            </div>
        </div>
    );
};

export default TenantInformation;
